<template>
<div class="content">
  <div class="header">
    <h1>{{ pageTitle }}</h1>
  </div>
  <div class="content-body table-wrapper">
    <div class="product-list block">
      <div class="product-finder--filter" style="display: flex; flex-flow: row; justify-content: flex-start; gap: 10px;">
        <Select v-model="filter.product_type" :placeholder="$t('product.info.product_type')" clearable>
          <Option value="product">{{ $t('product.info.product_type_product') }}</Option>
          <Option value="service">{{ $t('product.info.product_type_service') }}</Option>
        </Select>
        <Select v-model="filter.lifecycle_status" :placeholder="$t('product.info.lifecycle_status')" clearable>
          <Option value="active">{{ $t('product.info.product_status_active') }}</Option>
          <Option value="discontinued">{{ $t('product.info.product_status_discontinued') }}</Option>
        </Select>
        <Select v-model="filter.category" :placeholder="$t('product.info.category')" clearble>
          <Option value="turnkey">Turnkey</Option>
          <Option value="pcba">PCBA</Option>
          <Option value="pcb">PCB</Option>
          <Option value="accessory">Accessory</Option>
          <Option value="mould_tooling">Mould tooling</Option>
        </Select>
        <AccountSelect v-model="filter.customer_id" :placeholder="$t('quote.search_customer_placeholder')" clearable></AccountSelect>
        <Input v-model="filter.product_number" :placeholder="$t('product.enter_product_number')"></Input>
        <Input v-model="filter.product_name" :placeholder="$t('product.enter_product_name')"></Input>
        <Input v-model="filter.model" :placeholder="$t('product.enter_product_model')"></Input>
        <Button type="primary" @click="searchClicked">{{ $t('go') }}</Button>
      </div>
      <div class="product-finder--list" style="margin-top: 30px">
        <vxe-toolbar>
          <template #buttons>
            <div class="text-align-right">
              <Button type="primary" :to='{ name: "menu.product.new" }'>{{ $t('product.new_product') }}</Button>
            </div>
          </template>
        </vxe-toolbar>
        <vxe-table
          :loading="loading"
          :data="productList.data"
          size="mini"
          border>
          <vxe-column type="seq" width="60" align="center"></vxe-column>
          <vxe-column field="product_name" :title="$t('product.product_name')" :minWidth="400">
            <template #default="{ row }">
              <ProductNameWithThumbnail :product="row"></ProductNameWithThumbnail>
            </template>
          </vxe-column>
          <vxe-column field="model" :title="$t('product.info.product_model')" width="200"></vxe-column>
          <vxe-column field="product_number" :title="$t('product.product_number')" width="120"></vxe-column>
          <vxe-column field="product_type" :title="$t('product.product_type')" width="100">
            <template #default="{ row }"> {{ row.product_type ? row.product_type.toUpperCase() : '' }} </template>
          </vxe-column>
          <vxe-column field="data.category" :title="$t('product.category')" width="100">
            <template #default="{ row }"> {{ row.data && row.data.category ? row.data.category.toUpperCase() : '' }} </template>
          </vxe-column>
          <vxe-column field="customer.name" :title="$t('product.info.customer')" width="300">
            <template #default="{ row }">{{ row.customer ? row.customer.name : '' }}</template>
          </vxe-column>
          <vxe-column field="lifecycle_status" :title="$t('product.status')" width="100" align="center">
            <template #default="{ row }"><span class="ivu-badge info"><a href="#"></a><sup class="ivu-badge-count" :style="`background: ${row.lifecycle_status === 'active' ? '#19be6b' : '#3d4014'}`">{{ row.lifecycle_status }}</sup></span></template>
          </vxe-column>
          <vxe-column field="created_at" :title="$t('product.status')" width="160"></vxe-column>
          <vxe-column :title="$t('actions')" width="120" align="center">
            <template #default="{ row }">
              <router-link target="_blank" :to="{ name: 'menu.product.edit', params: { productId: row.id } }">{{ $t('edit') }}</router-link>
              <Button type="text" @click="handleDeleteClicked(row)" size="small">{{ $t('delete') }}</Button>
            </template>
          </vxe-column>
        </vxe-table>

        <vxe-pager
          border
          icon-prev-page="fa fa-angle-left"
          icon-jump-prev="fa fa-angle-double-left"
          icon-jump-next="fa fa-angle-double-right"
          icon-next-page="fa fa-angle-right"
          icon-jump-more="fa fa-ellipsis-h"
          :loading="loading"
          :current-page="pager.current_page"
          :page-size="pager.per_page"
          :total="pager.total"
          :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
          @page-change="handlePageChange">
        </vxe-pager>
      </div>
    </div>
  </div>
</div>
</template>

<script>

import ProductListWithFilter from './components/product-list-with-filter'
import ProductNameWithThumbnail from './components/product-name-with-thumbnail'
import { mapActions, mapGetters } from 'vuex'
import { AccountSelect } from '@/view/account/components'
export default {
  name: 'Products',
  components: {
    ProductListWithFilter,
    ProductNameWithThumbnail,
    AccountSelect
  },
  data () {
    return {
      ruleValidate: {
        part_number: [
          { required: true, message: 'Part Number cannot be empty!', trigger: 'change' }
        ],
        platform: [
          { required: true, message: 'Sync Mode cannot be empty!', trigger: 'change' }
        ]
      },
      product: null,
      filter: { product_type: null, product_name: '', product_number: '', lifecycle_status: 'active' },
      tableData: [],
      pager: {
        current_page: 1,
        per_page: 15,
        page: 1
      },
      loading: false
    }
  },
  computed: {
    ...mapGetters(['productList']),
    pageTitle () {
      document.title = this.$t('menu.product.product_list')
      return document.title
    }
  },
  mounted () {
    this.findProducts()
  },
  methods: {
    ...mapActions(['getProducts', 'deleteProduct']),
    searchClicked () {
      delete this.pager.current_page
      this.findProducts()
    },
    findProducts () {
      // Build search query with blank values removed
      this.loading = true
      this.getProducts(this.buildQuery()).then(resp => {
        if (resp.data.meta) {
          this.pager = (({ per_page, current_page, total }) => ({ per_page, current_page, total }))(resp.data.meta)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    buildQuery () {
      let search = Object.entries(this.filter).filter(([_, v]) => v).map((e) => {
        if (e[0] === 'category') {
          e[0] = 'data.category'
        }

        return e.join(':')
      }).join(';')

      return Object.assign({}, { search: search, searchJoin: 'and', orderBy: 'id', sortedBy: 'desc' }, this.pager)
    },
    handlePageChange ({ currentPage, pageSize }) {
      this.pager.page = currentPage
      this.pager.per_page = pageSize
      this.findProducts()
    },
    handleDeleteClicked (row) {
      this.deleteProduct(row.id)
    }
  }
}
</script>
